import { z } from 'zod';

export const FLOW_SESSION_STORAGE_KEY = 'v3_dti_flow_session';
export const DTI_FLOW_IDLE_EXPIRY_MS = 60 * 60 * 1_000;

// `noPagesToV3` prevents `src/pages/**` from importing `src/app/book/**`.
// `/book` remains the writer while `/` uses this module read-only.
const flowSessionPartnerSchema = z
  .object({
    updatedAtMs: z.number(),
    context: z
      .object({
        partnerCode: z.string().nullable().optional(),
      })
      .passthrough(),
  })
  .passthrough();

type FlowSessionPartnerRecord = z.infer<typeof flowSessionPartnerSchema>;

function readPersistedFlowSession(): FlowSessionPartnerRecord | null {
  if (typeof window === 'undefined') return null;

  let rawValue: string | null;
  try {
    rawValue = window.sessionStorage.getItem(FLOW_SESSION_STORAGE_KEY);
  } catch {
    return null;
  }

  if (rawValue === null) return null;

  try {
    const parsed: unknown = JSON.parse(rawValue);
    const result = flowSessionPartnerSchema.safeParse(parsed);
    return result.success ? result.data : null;
  } catch {
    return null;
  }
}

export function readFlowSessionPartnerCode(): string | null {
  const session = readPersistedFlowSession();
  if (session === null) return null;
  if (Date.now() - session.updatedAtMs > DTI_FLOW_IDLE_EXPIRY_MS) {
    return null;
  }

  const partnerCode = session.context.partnerCode;
  if (typeof partnerCode !== 'string') return null;

  const trimmedPartnerCode = partnerCode.trim();
  return trimmedPartnerCode === '' ? null : trimmedPartnerCode;
}
